// Safe localStorage helpers. localStorage can throw (private-browsing modes,
// quota exceeded, storage disabled), so every access is wrapped — callers get a
// fallback instead of an exception that could crash a React subtree.

export function safeGet(key, fallback = null) {
  try { const v = localStorage.getItem(key); return v === null ? fallback : v; }
  catch { return fallback; }
}

export function safeSet(key, value) {
  try { localStorage.setItem(key, value); return true; } catch { return false; }
}

export function safeRemove(key) {
  try { localStorage.removeItem(key); return true; } catch { return false; }
}

export function safeGetJSON(key, fallback = null) {
  try { const v = localStorage.getItem(key); return v == null ? fallback : JSON.parse(v); }
  catch { return fallback; }
}

export function safeSetJSON(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
}

export default { safeGet, safeSet, safeRemove, safeGetJSON, safeSetJSON };
